export default "__VITE_ASSET__BbICnZ9H__"